// import { useRef, useState } from 'react';
// import './tech.css';
// import { BrowserRouter, Link, NavLink, Outlet, Route, Routes } from "react-router-dom";
// import { All } from './all';
// import { Languages } from './language';
// import { Tools } from './tools';



// export function TechPage() {

//     let count = useRef();

//     const[style, setStyle] = useState('')

//     function handleAllTech(e) {
//         setStyle('d-none d-block')
//     }
//     function handleLanguage(e) {
        
//     }
//     function handleTools(e) {
        
//     }


//     return (
//         <div className="container-fluid bg bg-black d-flex justify-content-center align-items-center main-about " style={{ height: "100vh", width: "100%" }}>
//             <div className="tech-page z-1 ">
//                 <div className='tech-box1'>
//                     <div className='tech1-box1'>
//                         <h1>Stuff I know</h1>
//                     </div>
//                     <div className='tech1-box2'>
//                         <div className='tech1-box1-sub1'><span></span></div>
//                         <div className='tech-para'>
//                             <span className="text-faded">
//                                 I’m Prabhanjan Amanta, a Full Stack Java Developer passionate about building scalable, efficient, and interactive web applications. Skilled in
//                                 <span className="skills-highlight"> Microservices, ReactJS, Spring Boot, Apache Kafka, Redis Cache, REST APIs, and Java. </span>
//                                 I focus on delivering seamless user experiences backed by strong backend logic and clean architecture. I’m constantly learning and exploring new technologies while sharing knowledge through content creation to inspire and guide others in their development journey.
//                             </span>
//                         </div>
//                     </div>
//                     <div className='tech1-box3'>

//                         <NavLink
//                             to="all"
//                             className={({ isActive }) => isActive ? "navlink active" : "navlink"}
//                         >
//                             <div onClick={handleAllTech} className='tech1-box3-sub1'>
//                                 <span>ALL</span>
//                             </div>
//                         </NavLink>

//                         <NavLink
//                             to="languages"
//                             className={({ isActive }) => isActive ? "navlink active" : "navlink"}
//                         >
//                             <div onClick={handleLanguage} className='tech1-box3-sub2'>
//                                 <span>LANGUAGES</span>
//                             </div>
//                         </NavLink>

//                         <NavLink
//                             to="tools"
//                             className={({ isActive }) => isActive ? "navlink active" : "navlink"}
//                         >
//                             <div onClick={handleTools} className='tech1-box3-sub3'>
//                                 <span>TOOLS</span>
//                             </div>
//                         </NavLink>


//                     </div>
//                 </div>
//                 <div className='tech-box2'>
//                     {/* <Outlet /> */}
//                     <All style={style} />
//                     <Languages style={style}  />
//                     <Tools style={style} />
//                 </div>
//             </div>
//         </div>
//     )
// }

import { useRef, useState } from 'react';
import './tech.css';
import { All } from './all';
import { Languages } from './language';
import { Tools } from './tools';

export function TechPage() {
    const [activeTab, setActiveTab] = useState('all'); // default visible tab

    function handleAllTech() {
        setActiveTab('all');
    }

    function handleLanguage() {
        setActiveTab('language');
    }

    function handleTools() {
        setActiveTab('tools');
    }

    return (
        <div className="container-fluid bg bg-black d-flex justify-content-center align-items-center main-about"
            style={{ height: "100vh", width: "100%" }}>
            <div className="tech-page z-1">
                <div className='tech-box1'>
                    <div className='tech1-box1'>
                        <h1>Stuff I know</h1>
                    </div>
                    <div className='tech1-box2'>
                        <div className='tech1-box1-sub1'><span></span></div>
                        <div className='tech-para'>
                            <span className="text-faded">
                                I’m Prabhanjan Amanta, a Full Stack Java Developer passionate about building scalable, efficient, and interactive web applications. Skilled in
                                <span className="skills-highlight"> Microservices, ReactJS, Spring Boot, Apache Kafka, Redis Cache, REST APIs, and Java. </span>
                                I focus on delivering seamless user experiences backed by strong backend logic and clean architecture. I’m constantly learning and exploring new technologies while sharing knowledge through content creation to inspire and guide others in their development journey.
                            </span>
                        </div>
                    </div>

                    {/* Buttons */}
                    <div className='tech1-box3'>
                        <div onClick={handleAllTech} className={`tech1-box3-sub1 ${activeTab === 'all' ? 'active-tab' : ''}`}>
                            <span>ALL</span>
                        </div>
                        <div onClick={handleLanguage} className={`tech1-box3-sub2 ${activeTab === 'language' ? 'active-tab' : ''}`}>
                            <span>LANGUAGES</span>
                        </div>
                        <div onClick={handleTools} className={`tech1-box3-sub3 ${activeTab === 'tools' ? 'active-tab' : ''}`}>
                            <span>TOOLS</span>
                        </div>
                    </div>
                </div>

                {/* Display area */}
                <div className='tech-box2'>
                    <All style={activeTab === 'all' ? 'd-block' : 'd-none'} />
                    <Languages style={activeTab === 'language' ? 'd-block' : 'd-none'} />
                    <Tools style={activeTab === 'tools' ? 'd-block' : 'd-none'} />
                </div>
            </div>
        </div>
    );
}



